export const enum RoutPaths {
    MAIN = "/",
//     USERS = "/users/",
//     USER = "/users/:id",
//     TODOS = "/todos"
}